<template>
  <v-app class="main-page" id="inspire">
    <flash-message
      v-if="alertToggle"
      :message-data="flashMessageData"
      :alert-toggle="alertToggle"
      :do-translation="stringTranslation"
      @alertToggleUpdate="alertToggle = false"
    ></flash-message>
    <about-to-expire-flash
      v-if="alertToggle"
      :message-data="expireFlashMessageData"
      :alert-toggle="expireFlashToggle"
      :do-translation="true"
      :expire-flash="true"
      @alertToggleUpdate="expireFlashToggle = false"
    ></about-to-expire-flash>
    <div class="desktop-screen d-menu-bar">
      <app-menu page-name="Home"></app-menu>
      <div
        class="sub-menu sub-menu-small h-auto"
        v-if="controllerData.miscdata"
      >
        <v-btn
          flat
          class="pa-2"
          :disabled="
            getUser.credentials === 'readonly' ||
              (controllerData.miscdata.alarm === 1 &&
                controllerData.miscdata.state.value === 'state_12')
          "
          @click="controllerAction = true"
        >
          <v-img
            :src="require('../assets/images/icons/button_onoff.png')"
            contain
            width="50"
            height="50"
          ></v-img>
          <span v-bind:class="[{ controllerOn: 'controller-on' }, 'py-2']">
            {{ "lng_onoff" | translate }}
          </span>
        </v-btn>
        <v-btn flat class="pa-2" @click="authAction">
          <v-img
            :src="require('../assets/images/icons/btn-1-login.png')"
            contain
            width="50"
            height="50"
          ></v-img>
          <span v-if="getUser.credentials === 'readonly'" class="py-2">{{
            "login"
          }}</span>
          <span v-if="getUser.credentials === 'full'" class="py-2">{{
            "logout"
          }}</span>
        </v-btn>
      </div>
    </div>
    <v-layout row class="desktop-screen selector-block max-height28">
      <v-flex
        xs3
        md3
        lg2
        offset-lg1
        v-if="fieldSetData && fieldSetData[3]['@attributes'].name == 'weather'"
      >
        <home-select-lists
          v-if="controllerData && controllerData.weatherdata"
          :select-options="fieldSetData[3].field"
          :controller-data="controllerData.weatherdata"
          @saveSelectFieldData="saveSelectFieldData($event, 'w')"
        />
      </v-flex>
      <v-flex xs6 md6 class="px-2">
        <home-info-section
          v-if="controllerData && controllerData.miscdata"
          :controller-data="controllerData.miscdata"
          :info-messages="controllerData.infomessages"
          @openInfoMessages="openInfoMessagesModal"
        />
        <v-btn
          large
          class="reset-alarm"
          v-if="
            controllerData.miscdata &&
              controllerData.miscdata.alarm &&
              controllerData.miscdata.state.value !== 'state_12'
          "
          :disabled="getUser.credentials === 'readonly'"
          @click="openResetAlarmModal()"
          >{{ "lng_reset_alarm" | translate }}</v-btn
        >
      </v-flex>
      <weather-comp
        :key="weatherCompKey"
        v-if="controllerData && controllerData.weathercomp"
        :controller-data="controllerData.weathercomp"
      ></weather-comp>
    </v-layout>
    <v-layout row class="desktop-screen info-buttons" v-if="controllerData">
      <v-flex xs4 md4 class="px-2">
        <v-layout
          align-center
          class="home sub-menu sub-menu-small sub-menu-small-1 h-auto"
        >
          <div
            class="inner-buttons"
            v-for="(value, propertyName, index) in controllerData.leftoutput"
            :key="propertyName + index"
          >
            <home-info-modals
              v-if="value.val !== 'disabled'"
              :output-data="value"
              :property="propertyName"
              api-param="output"
            />
          </div>
        </v-layout>
      </v-flex>
      <v-flex xs4 md4 class="px-2"></v-flex>
      <v-flex xs4 md4 class="px-2">
        <v-layout
          align-center
          justify-end
          class="home sub-menu sub-menu-small sub-menu-small-1 h-auto"
        >
          <div
            class="inner-buttons"
            v-for="(value, propertyName, index) in controllerData.rightoutput"
            :key="propertyName + index"
          >
            <home-info-modals
              v-if="value.val !== 'disabled'"
              :output-data="value"
              :property="propertyName"
              api-param="sunoutput"
            />
          </div>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout row align-end class="desktop-screen devices-info mb-2">
      <v-flex
        xs4
        md4
        class="px-0 boiler-block"
        v-if="fieldSetData && fieldSetData[0]['@attributes'].name == 'boiler'"
      >
        <div class="mx-2">
          <v-layout row class="main-page-list">
            <v-flex xs12 text-md-center>
              <span v-if="expiryDetails && !expiryDetails.paymentenabled" 
                class="colored-box" :style="{backgroundColor: 'gray'}"></span>
              <span v-else-if="expiryDetails && expiryDetails.paymentenabled && expiryDetails.expireflag == 2" 
                class="colored-box" :style="{backgroundColor: 'green'}"></span>
              <span v-else-if="expiryDetails && expiryDetails.paymentenabled && expiryDetails.expireflag == 0" 
                class="colored-box" :style="{backgroundColor: 'red'}"></span>
              {{
                controllerData.serial
                  ? controllerData.serial + " / " + controllerData.alias
                  : " / " + controllerData.alias
              }}
            </v-flex>
          </v-layout>
          <home-select-lists
            v-if="controllerData && controllerData.boilerdata"
            :select-options="fieldSetData[0].field"
            :controller-data="controllerData.boilerdata"
            :front-data="controllerData.frontdata"
            @saveSelectFieldData="saveSelectFieldData($event, 'b')"
          />
        </div>
        <boiler-image
          v-if="controllerData"
          :controller-data="controllerData"
          @imageNavigation="imageNavigation('/boiler')"
        />
      </v-flex>
      <v-flex
        xs4
        md4
        class="px-0 boiler-block hopper-block"
        v-if="fieldSetData && fieldSetData[1]['@attributes'].name == 'hopper'"
      >
        <hopper-image
          v-if="controllerData"
          :controller-data="controllerData"
          @imageNavigation="imageNavigation('/hopper')"
        />
        <home-select-lists
          v-if="controllerData && controllerData.hopperdata"
          :select-options="fieldSetData[1].field"
          :controller-data="controllerData.hopperdata"
          @saveSelectFieldData="saveSelectFieldData($event, 'h')"
        />
      </v-flex>
      <v-flex
        xs4
        md4
        class="px-0 boiler-block dhw-device-block"
        v-if="fieldSetData && fieldSetData[2]['@attributes'].name == 'dhw'"
      >
        <v-btn
          flat
          class="pa-0 boiler-button boiler-button-3 mr-2"
          @click="imageNavigation('/dhw')"
        >
          <div v-if="controllerData.frontdata" class="on-button-text">
            <p v-if="controllerData.frontdata[3].id === 'dhw'" class="mb-0">
              {{ controllerData.frontdata[3].value | tempConversion }}
              {{ controllerData.frontdata[3].unit | translate }}
            </p>
            <p
              v-if="controllerData.frontdata[4].id === 'dhwwanted'"
              class="mb-0"
            >
              ({{ controllerData.frontdata[4].value | tempConversion }}
              <span v-if="controllerData.frontdata[4].value !== 'N/A'"
                >{{ controllerData.frontdata[4].unit | translate }})</span
              >
            </p>
          </div>
          <v-img
            :src="require('../assets/images/Varmvandsbeholder-App-front.png')"
          ></v-img>
        </v-btn>
        <home-select-lists
          v-if="controllerData && controllerData.dhwdata"
          :select-options="fieldSetData[2].field"
          :controller-data="controllerData.dhwdata"
          @saveSelectFieldData="saveSelectFieldData($event, 'd')"
        />
      </v-flex>
    </v-layout>
    <refresh-timer
      v-if="showTimer"
      :refresh-time="pageRefreshTime"
      :refresh-page="refreshPage"
      :show-count-down="false"
      :key="timerKey"
    ></refresh-timer>
    <reset-alarm-modal
      :open-dialog="openResetAlarm"
      :close-dialog="closeResetAlarmModal"
      :give-access="resetAlarm"
      message-text="lng_reset_alarm_warning"
    />
    <help-dialog
      dialog-title="Invalid"
      help-text="Only v16 controllers are supported on this cloud."
      :openDialog="loginRedirection"
      :closeDialog="closeRedirectLoginDialog"
    ></help-dialog>
    <user-logout-modal
      :open-dialog="openResetAuth"
      :close-dialog="closeLogoutModal"
      :give-access="userLogout"
      :message-text="logoutText1 + logoutText2"
      :translate="false"
      messageTitle="lng_logout_title"
    />
    <stop-controller-modal
      :open-dialog="controllerAction"
      :close-dialog="closeContrllerModal"
      :give-access="stopController"
      :message-text="
        controllerOn ? 'lng_on_off_subtitle' : 'lng_start_subtitle'
      "
      :messageTitle="
        controllerOn ? 'lng_stop_controller' : 'lng_start_controller'
      "
    />
    <home-info-messages-modal
      :open-dialog="infoMessageModal"
      :close-dialog="closeInfoMessagesModal"
      :message-text="infoMessagesData"
      messageTitle="lng_info"
    />
    <conditions-dialog
      :open-dialog="openConditionDialog"
      :close-dialog="closeConditionsModal"
      :give-access="acceptTerms"
      messageTitle="lng_terms_condition_text"
    />
    <expire-info-modal
      :open-dialog="expireModalToggle"
      :close-dialog="closeExpireModal"
      :give-access="openPlans"
      message-title="lng_expiry_alert_modal_title"
      :message-text="expiryDetails ? expiryDetails.text : ''"
      ok-button-text="lng_go_to_payment_text"
      :html-content="true"
    />
    <div class="mobile-screen">
      <div
        :class="[mobileSidebar ? 'display-block' : '', 'sidebar-bg']"
        @click="mobileSidebar = false"
      ></div>
      <div :class="[mobileSidebar ? 'open-sidebar-menu' : '', 'sidebar-menu']">
        <div class="logo-item md-no-proxy">
          <img src="../assets/images/icons/ic_launcher.png" />
          <button @click="mobileSidebar = false">
            <img
              src="../assets/images/icons/left-arrow.png"
              height="28"
              width="28"
            />
          </button>
        </div>
        <!-- <app-menu page-name="mobile"></app-menu> -->
        <app-menu
          page-name="mobile"
          :expiry-flag="controllerData.expireflag"
        ></app-menu>
        <div class="sub-menu sub-menu-small h-auto">
          <v-btn
            v-if="controllerData.miscdata"
            flat
            class="pa-2"
            :disabled="
              getUser.credentials === 'readonly' ||
                (controllerData.miscdata.alarm === 1 &&
                  controllerData.miscdata.state.value === 'state_12')
            "
            @click="controllerAction = true"
          >
            <v-img
              :src="require('../assets/images/icons/button_onoff.png')"
              contain
              width="50"
              height="50"
            ></v-img>
            <span v-bind:class="[{ controllerOn: 'controller-on' }, 'py-2']">
              {{ "lng_onoff" | translate }}
            </span>
          </v-btn>
          <v-btn flat class="pa-2" @click="authAction">
            <v-img
              :src="require('../assets/images/icons/btn-1-login.png')"
              contain
              width="50"
              height="50"
            ></v-img>
            <span v-if="getUser.credentials === 'readonly'" class="py-2">{{
              "login"
            }}</span>
            <span v-if="getUser.credentials === 'full'" class="py-2">{{
              "logout"
            }}</span>
          </v-btn>
        </div>
      </div>
      <v-flex xs12 class="pa-2">
        <home-info-section
          v-if="controllerData && controllerData.miscdata"
          :controller-data="controllerData.miscdata"
          :info-messages="controllerData.infomessages"
          @openInfoMessages="openInfoMessagesModal"
        />
        <button @click="mobileSidebar = true" class="menu-button">
          <svg
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            fit
            height="100%"
            width="100%"
            preserveAspectRatio="xMidYMid meet"
            focusable="false"
          >
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
          </svg>
        </button>
        <v-btn
          large
          class="reset-alarm"
          v-if="
            controllerData.miscdata &&
              controllerData.miscdata.alarm &&
              controllerData.miscdata.state.value !== 'state_12'
          "
          :disabled="getUser.credentials === 'readonly'"
          @click="openResetAlarmModal()"
          >{{ "lng_reset_alarm" | translate }}</v-btn
        >
      </v-flex>
      <v-layout
        align-center
        class="home sub-menu sub-menu-small sub-menu-small-1 h-auto"
      >
        <div
          class="inner-buttons"
          v-for="(value, propertyName, index) in controllerData.leftoutput"
          :key="propertyName + index"
        >
          <home-info-modals
            v-if="value.val !== 'disabled'"
            :output-data="value"
            :property="propertyName"
            api-param="output"
          />
        </div>
      </v-layout>
      <div class="devices-info-field">
        <!--  mobile boiler content  -->
        <div class="boiler-info layout-row" layout="row">
          <img src="../assets/images/icons/btn_boiler_rtb.png" />
          <div v-if="controllerData.frontdata" class="on-button-text">
            <span
              v-if="controllerData.frontdata[1].id === 'boilertemp'"
              class="mb-0"
            >
              {{ controllerData.frontdata[1].value | tempConversion }}
              {{ controllerData.frontdata[1].unit | translate }}
            </span>
            <span
              v-if="controllerData.frontdata[2].id === '-wantedboilertemp'"
              class="mb-0"
            >
              ({{ controllerData.frontdata[2].value | tempConversion }}
              {{ controllerData.frontdata[2].unit | translate }})
            </span>
          </div>
        </div>
        <ul class="home-page-md-list-first">
          <li>
            <span v-if="expiryDetails && !expiryDetails.paymentenabled" 
              class="colored-box" :style="{backgroundColor: 'gray'}"></span>
            <span v-else-if="expiryDetails && expiryDetails.paymentenabled && expiryDetails.expireflag == 2" 
              class="colored-box" :style="{backgroundColor: 'green'}"></span>
            <span v-else-if="expiryDetails && expiryDetails.paymentenabled && expiryDetails.expireflag == 0" 
              class="colored-box" :style="{backgroundColor: 'red'}"></span>
            <span>
              {{
                controllerData.serial
                  ? controllerData.serial + " / " + controllerData.alias
                  : " / " + controllerData.alias
              }}
            </span>
          </li>
        </ul>
        <ul
          class="home-page-md-list"
          v-if="controllerData && controllerData.boilerdata"
        >
          <div
            v-for="(item, index) in controllerData.boilerdata"
            :key="item.id + index"
          >
            <li
              class="md-no-proxy"
              v-if="
                item.value &&
                  item.value !== '' &&
                  item.value !== null &&
                  item.value !== 'N/A'
              "
            >
              <span>{{ item.value }} {{ item.unit | translate }}</span>
              <span>{{ parseName(item.name) }}</span>
              <span
                class="ref-oxygen"
                v-if="item.id === '12' && getfrontDataValue('refoxygen')"
              >
                ({{ getfrontDataValue("refoxygen") }})</span
              >
              <span
                class="ref-oxygen"
                v-if="item.id === '26' && getfrontDataValue('refair')"
              >
                ({{ getfrontDataValue("refair") }})</span
              >
            </li>
          </div>
        </ul>

        <!--  mobile hopper content  -->
        <div class="boiler-info layout-row" layout="row">
          <img src="../assets/images/icons/btn-9-hopper.png" />
          <div v-if="controllerData.frontdata" class="on-button-text">
            <span
              v-if="controllerData.frontdata[0].id === 'hoppercontent'"
              class="mb-0"
            >
              {{ controllerData.frontdata[0].value | weightConversion }}
              {{ controllerData.frontdata[0].unit | translate }}
            </span>
          </div>
        </div>
        <ul
          class="home-page-md-list"
          v-if="controllerData && controllerData.hopperdata"
        >
          <div
            v-for="(item, index) in controllerData.hopperdata"
            :key="item.id + index"
          >
            <li
              class="md-no-proxy"
              v-if="
                item.value &&
                  item.value !== '' &&
                  item.value !== null &&
                  item.value !== 'N/A'
              "
            >
              <span>{{ item.value }} {{ item.unit | translate }}</span>
              <span>{{ parseName(item.name) }}</span>
            </li>
          </div>
        </ul>

        <!--  mobile dhw content  -->
        <div class="boiler-info layout-row" layout="row">
          <img src="../assets/images/icons/btn-4-hwt.png" />
          <div v-if="controllerData.frontdata" class="on-button-text">
            <span v-if="controllerData.frontdata[3].id === 'dhw'" class="mb-0">
              {{ controllerData.frontdata[3].value | tempConversion }}
              {{ controllerData.frontdata[3].unit | translate }}
            </span>
            <span
              v-if="controllerData.frontdata[4].id === 'dhwwanted'"
              class="mb-0"
            >
              ({{ controllerData.frontdata[4].value | tempConversion }}
              <span v-if="controllerData.frontdata[4].value !== 'N/A'"
                >{{ controllerData.frontdata[4].unit | translate }})</span
              >
            </span>
          </div>
        </div>
        <ul
          class="home-page-md-list"
          v-if="controllerData && controllerData.dhwdata"
        >
          <div
            v-for="(item, index) in controllerData.dhwdata"
            :key="item.id + index"
          >
            <li
              class="md-no-proxy"
              v-if="
                item.value &&
                  item.value !== '' &&
                  item.value !== null &&
                  item.value !== 'N/A'
              "
            >
              <span>{{ item.value }} {{ item.unit | translate }}</span>
              <span>{{ parseName(item.name) }}</span>
            </li>
          </div>
        </ul>

        <!--  mobile weather content  -->
        <div class="boiler-info layout-row" layout="row">
          <img src="../assets/images/icons/button_solar_heat.png" />
          <div v-if="controllerData.weatherdata" class="on-button-text">
            <span
              v-if="
                controllerData.weatherdata[0] &&
                  controllerData.weatherdata[0].id == 'weather-city'
              "
              class="mb-0"
              >{{ controllerData.weatherdata[0].value }}</span
            >
          </div>
        </div>
        <ul
          class="home-page-md-list"
          v-if="controllerData && controllerData.weatherdata"
        >
          <div
            v-for="(item, index) in controllerData.weatherdata"
            :key="item.id + item.selection + index"
          >
            <li
              class="md-no-proxy"
              v-if="item.value && item.id !== 'weather-city'"
            >
              <span>{{ item.value }} {{ item.unit | translate }}</span>
              <span>{{ parseName(item.name) }}</span>
            </li>
          </div>
        </ul>

        <!--  Weather component  -->
        <weather-comp
          :key="weatherCompKey"
          v-if="controllerData && controllerData.weathercomp"
          :controller-data="controllerData.weathercomp"
        ></weather-comp>
      </div>
    </div>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import GlobalService from "../services/global-service";
import UserService from "../services/user-service";
import Menu from "../components/menus/Menu.vue";
import HomeSelectLists from "../components/home/HomeSelectLists";
import HomeInfoSection from "../components/home/HomeInfoSection";
import WeatherComp from "./../components/WeatherComp";
import FlashMessage from "../components/FlashMessage";
import RefreshTimer from "../components/RefreshTimer";
import { flashMessagesData } from "./../common/Constant.js";
import TechAccessDialog from "../components/TechAccessDialog";
import HopperImage from "../components/HopperImage";
import BoilerImage from "../components/BoilerImage";
// import I18n from "../components/internationalization/i18n";
import { translate } from "../common/HelperFunctions";
import HomeInfoModals from "./../components/home/HomeInfoModals";
import HomeInfoMessagesModal from "./../components/home/HomeInfoMessagesModal";
import router from "../router.js";
import HelpDialog from "../components/HelpDialog";
import ConditionsDialog from "../components/home/ConditionsDialog";

export default {
  components: {
    appMenu: Menu,
    HomeSelectLists,
    ResetAlarmModal: TechAccessDialog,
    UserLogoutModal: TechAccessDialog,
    StopControllerModal: TechAccessDialog,
    expireInfoModal: TechAccessDialog,
    HomeInfoSection,
    WeatherComp,
    RefreshTimer,
    FlashMessage,
    AboutToExpireFlash: FlashMessage,
    HopperImage,
    BoilerImage,
    HomeInfoModals,
    HelpDialog,
    HomeInfoMessagesModal,
    ConditionsDialog
  },
  data: () => ({
    menuData: undefined,
    fieldSetData: undefined,
    controllerData: {},
    alertToggle: false,
    flashMessageData: {},
    pageRefreshTime: 5,
    timerKey: 0,
    showTimer: false,
    openResetAlarm: false,
    stringTranslation: true,
    loginRedirection: false,
    openResetAuth: false,
    logoutText1: translate("lng_logout_line_1"),
    logoutText2: translate("lng_logout_line_2"),
    controllerAction: false,
    prevDataStatus: null,
    newDataStatus: null,
    infoMessageModal: false,
    infoMessagesData: [],
    mobileSidebar: false,
    controllerOn: false,
    openConditionDialog: false,
    weatherCompKey: 0,
    expireModalToggle: false,
    expireFlashToggle: false,
    expireFlashMessageData: {
      messageText: "lng_expire_soon_text",
      showRegisterButton: true,
      color: "#eecb0e"
    },
    expiryDetails: undefined
  }),
  mounted() {
    document.getElementsByTagName("html")[0].className = "home-page";
    this.chooseLanguage();

    window.onhashchange = function() {
      router.go();
    };

    const sessionStoreUserData = JSON.parse(sessionStorage.vuex);
    let data = window.location.href.split("/");
    let url = "";
    data.forEach((element, index) => {
      url =
        index == 3
          ? `${url}#${sessionStoreUserData.user.user.name}`
          : `${url}${element}/`;
    });
    window.location.href = url;

    document.addEventListener(
      "visibilitychange",
      function() {
        if (!document.hidden) {
          this.timerKey += 1;
          // console.log('well back',  document.visible);
        }
      },
      false
    );
  },
  computed: {
    ...mapGetters("user", ["getUser"])
  },
  async created() {
    this.$store.commit("global/setLoading", true);
    await this.getMenuItems();
    await this.checkTerms();
    await this.FetchApisData();
    await this.FetchPaymentExpiryDetails();
    let status = await GlobalService.getStatus(this.getUser.token);
    this.prevDataStatus = status.date;
    this.newDataStatus = status.date;
    this.addForPlusItem();
    this.$store.commit("global/setLoading", false);
    this.flashMessageData = this.getFlashMessageData();
  },
  methods: {
    async updateStatusTimer() {
      let status = window.localStorage.getItem("updateStatusTimer");
      if (status && status > 0 && status < 15) {
        let updateInterval = setInterval(() => {
          /////////////// status api ///////////////////////
          this.refreshPage();
          status++;
          window.localStorage.setItem("updateStatusTimer", status);
          // console.log('on home: ', status);
          if (status > 15) {
            clearInterval(updateInterval);
          }
        }, 1000);
      }
    },
    async checkTerms() {
      if (this.getUser.credentials !== "readonly" && this.getUser.token) {
        let resTerms = await GlobalService.acceptTerms(
          null,
          0,
          this.getUser.token
        );
        if (
          resTerms.status === "0" &&
          resTerms.accepted_terms_version !== "2"
        ) {
          this.openConditionDialog = true;
        }
      }
    },
    // login function
    async login(userName) {
      let response;
      try {
        response = await UserService.login(userName, "");
      } catch (e) {
        router.push("/login");
      }
      if (!response.status) {
        this.$store.commit("user/setUser", {
          name: userName,
          token: response.token,
          master: response.master,
          credentials: response.credentials
        });
        // window.location.href = url;
      } else {
        router.push("/login");
      }
    },
    imageNavigation(path) {
      router.push(path);
    },
    parseName(name) {
      return name ? translate(name).split(" (")[0] : name;
      // return translate(name);
    },
    // refresh the page after timer reached
    async getMenuItems() {
      try {
        this.menuData = await GlobalService.getMenu(
          "screen",
          this.getUser.token
        );
        if (this.menuData && this.menuData.status === "error") router.push("/login");
        if (this.menuData)
          this.fieldSetData = this.menuData.menu.fieldsets.fieldset;
      } catch (e) {
        // this.closeRedirectLoginDialog();
        console.log("failed data");
        // router.push("/login");
      }
    },
    async refreshPage() {
      let status = await GlobalService.getStatus(this.getUser.token);
      this.newDataStatus = status.date;
      // this.pageRefreshTime = 5;

      if (this.newDataStatus) {
        if (this.prevDataStatus !== this.newDataStatus) {
          await this.FetchApisData();
          this.addForPlusItem();
          this.flashMessageData = this.getFlashMessageData();
          this.prevDataStatus = this.newDataStatus;
        }
      }
      this.timerKey += 1;
    },
    // set the selected language
    async chooseLanguage() {
      let storageLang = localStorage.getItem("language");
      if (storageLang) {
        // window.I18n = new I18n(storageLang);
        window.selectedLang = await GlobalService.getLang(storageLang);
      }
    },
    // setData for flash message
    getFlashMessageData() {
      if (
        this.controllerData.newuser &&
        this.getUser.credentials === "readonly"
      ) {
        this.alertToggle = true;
        return flashMessagesData.newuserReadonly;
      } else if (
        this.controllerData.newuser &&
        this.getUser.credentials === "full"
      ) {
        this.alertToggle = true;
        return flashMessagesData.newuserFull;
      } else if (this.controllerData.notconnected) {
        this.alertToggle = true;
        return flashMessagesData.userNotconnected;
      }
    },
    // get localStorage data
    getLocalScreenData() {
      return localStorage.getItem("screenValues");
    },
    // set localStorage data
    setLocalScreenData(key, screenObject) {
      localStorage.setItem(key, screenObject);
    },
    // function to fetch Controller Data
    async FetchApisData() {
      const screenData = this.getScreenData();
      this.controllerData = await GlobalService.getHomeFieldsData(
        screenData,
        this.getUser.token
      );
      if (
        this.controllerData &&
        this.controllerData.weatherdata.length &&
        this.controllerData.weatherdata[0].id === "weather-city" &&
        this.controllerData.weatherdata[0].value === "tokenexpired"
      ) {
        this.userLogout();
      }
      if (this.controllerData.type !== "v16") {
        this.loginRedirection = true;
      }
      this.controllerOn = this.controllerData.miscdata.running === 1;
      localStorage.setItem("userRegistered", !this.controllerData.newuser);
      localStorage.setItem("adminUser", this.controllerData.admin);
      this.setScreenStorageObject();
      this.showTimer = true;
      this.updateStatusTimer();
      this.weatherCompKey += 1;
      // check payment status and set user access accordingly
      if(this.controllerData.expireflag == 0){
        this.$store.commit("user/setUserCredentials", "readonly");
      }
    },
    async FetchPaymentExpiryDetails() {
      this.expiryDetails = await GlobalService.getPaymentExpiryDetails(this.getUser.token);

      localStorage.setItem("expiryFlag", this.expiryDetails.expireflag);
      localStorage.setItem("expirydate", this.expiryDetails.expirydate);
      localStorage.setItem("paymentenabled", this.expiryDetails.paymentenabled);

      if (
        this.expiryDetails.paymentenabled && 
        this.expiryDetails.expireflag === 0 && 
        !sessionStorage.getItem("showExpireDialog") 
      ) {
        this.expireModalToggle = true;
        sessionStorage.setItem("showExpireDialog", true);
      }

      // if (
      //   expiryDetails.expireflag !== undefined &&
      //   expiryDetails.expireflag !== 3
      // ) {
      //   if (
      //     this.controllerData.expireflag === 0 &&
      //     !sessionStorage.getItem("showExpireDialog")
      //   ) {
      //     this.expireModalToggle = true;
      //     sessionStorage.setItem("showExpireDialog", true);
      //   } else if (this.controllerData.expireflag === 1)
      //     this.expireFlashToggle = true;
      // }
      
    },
    getfrontDataValue(key) {
      if (this.controllerData.frontdata) {
        let data = this.controllerData.frontdata.find(e => e.id === key);
        return data ? data.value : "";
      } else {
        return "";
      }
    },
    closeRedirectLoginDialog() {
      this.loginRedirection = false;
      this.userLogout();
    },
    // logout user
    async userLogout() {
      let response = await GlobalService.logoutUser(this.getUser.token);
      if (!response.status) {
        localStorage.removeItem("user");
        this.$store.commit("user/setUser", {
          name: this.getUser.name,
          token: "",
          master: "",
          credentials: ""
        });
        router.push("/login");
      }
    },
    // add an Object for plus(+) in controllerData's components
    addForPlusItem() {
      let plusObject = { id: 0, selection: 0 };
      this.controllerData.boilerdata.length < 10
        ? this.controllerData.boilerdata.push(plusObject)
        : null;
      this.controllerData.dhwdata.length < 10
        ? this.controllerData.dhwdata.push(plusObject)
        : null;
      this.controllerData.hopperdata.length < 10
        ? this.controllerData.hopperdata.push(plusObject)
        : null;
      this.controllerData.weatherdata.length < 7
        ? this.controllerData.weatherdata.push(plusObject)
        : null;
    },
    // get screenValues from localStorage
    getScreenData() {
      let screen = this.getLocalScreenData("screenValues");
      if (!screen) {
        const defaultObject = this.setDefaultScreenStorageObject();
        this.setLocalScreenData("screenValues", defaultObject);
        return "";
      }
      return screen;
    },
    // set default screenValues to localStorage
    setDefaultScreenStorageObject() {
      let storageObject = [];
      for (let i = 1; i <= 10; i++) {
        storageObject.push("b" + i, "0");
      }
      for (let i = 1; i <= 10; i++) {
        storageObject.push("d" + i, "0");
      }
      for (let i = 1; i <= 10; i++) {
        storageObject.push("h" + i, "0");
      }
      for (let i = 1; i <= 5; i++) {
        storageObject.push("w" + i, "0");
      }
      return storageObject;
    },
    // set the screenValues Key to localStorage
    setScreenStorageObject() {
      const data = this.controllerData;
      let SplitedScreenData = this.getLocalScreenData("screenValues").split(
        ","
      );
      if (data.boilerdata && data.boilerdata.length) {
        for (let i = 0; i < data.boilerdata.length; i++) {
          let index = this.findScreenObjectIndex(
            SplitedScreenData,
            data.boilerdata[i],
            "b"
          );
          if (index) {
            SplitedScreenData[index + 1] = data.boilerdata[i].id;
          }
        }
      }
      if (data.dhwdata && data.dhwdata.length) {
        for (let i = 0; i < data.dhwdata.length; i++) {
          let index = this.findScreenObjectIndex(
            SplitedScreenData,
            data.dhwdata[i],
            "d"
          );
          if (index) {
            SplitedScreenData[index + 1] = data.dhwdata[i].id;
          }
        }
      }
      if (data.hopperdata && data.hopperdata.length) {
        for (let i = 0; i < data.hopperdata.length; i++) {
          let index = this.findScreenObjectIndex(
            SplitedScreenData,
            data.hopperdata[i],
            "h"
          );
          if (index) {
            SplitedScreenData[index + 1] = data.hopperdata[i].id;
          }
        }
      }
      if (data.weatherdata && data.weatherdata.length) {
        for (let i = 0; i < data.weatherdata.length; i++) {
          let index = this.findScreenObjectIndex(
            SplitedScreenData,
            data.weatherdata[i],
            "w"
          );
          if (index) {
            SplitedScreenData[index + 1] = data.weatherdata[i].id;
          }
        }
      }

      this.setLocalScreenData("screenValues", SplitedScreenData.toString());
    },
    // find the specific Index from screenValues
    findScreenObjectIndex(ScreenData, data, str) {
      if (str == "b" && data.selection !== "") {
        let dhwIndex = data.selection.slice(6);
        return ScreenData.indexOf(str + dhwIndex);
      }
      if (str == "d" && data.selection !== "") {
        let dhwIndex = data.selection.slice(3);
        return ScreenData.indexOf(str + dhwIndex);
      }
      if (str == "h" && data.selection !== "") {
        let dhwIndex = data.selection.slice(6);
        return ScreenData.indexOf(str + dhwIndex);
      }
      if (str == "w" && data.selection !== "") {
        let dhwIndex = data.selection.slice(7);
        return ScreenData.indexOf(str + dhwIndex);
      }
    },
    // find the next available index from screenValues
    findNextAvailable(splitedData, str) {
      for (let i = 0; i < splitedData.length; i += 2) {
        if (splitedData[i].split("")[0] == str) {
          if (splitedData[i + 1] == 0) {
            return i;
          }
        }
      }
      return -1;
    },
    // return the index from ScreenValues
    findIndexFromScreenValues(SplitedScreenData, data, str) {
      if (data.selection) {
        return this.findScreenObjectIndex(SplitedScreenData, data, str);
      } else {
        return this.findNextAvailable(SplitedScreenData, str);
      }
    },
    // update the select fieldData
    async saveSelectFieldData(data, str) {
      let SplitedScreenData = this.getLocalScreenData("screenValues").split(
        ","
      );
      let index = await this.findIndexFromScreenValues(
        SplitedScreenData,
        data,
        str
      );
      if (index >= 0) {
        SplitedScreenData[index + 1] = data.id;
      }
      this.setLocalScreenData("screenValues", SplitedScreenData.toString());
      this.controllerData = await GlobalService.getHomeFieldsData(
        SplitedScreenData.toString(),
        this.getUser.token
      );
      this.addForPlusItem();
    },
    // open alarm modal
    openResetAlarmModal() {
      this.openResetAlarm = true;
    },
    // close alarm modal
    closeResetAlarmModal() {
      this.openResetAlarm = false;
    },
    // reset the alarm
    async resetAlarm() {
      this.openResetAlarm = false;
      let response;
      try {
        response = await GlobalService.resetAlarmField(
          "misc.resetalarm",
          this.getUser.token,
          1
        );
      } catch (e) {
        var resObj = { status: 1, message: "Try again later" };
        this.showResetAlarmFlash(resObj);
      }
      this.showResetAlarmFlash(response);
    },
    // set data to show reset alarm flash message
    showResetAlarmFlash(response) {
      this.alertToggle = false;
      this.stringTranslation = false;
      this.flashMessageData = {
        messageText:
          response.status === "0"
            ? `${translate("web_saving")} ${
                response.secs_to_next_update
              } ${translate("lng_sec")}`
            : `Failure! ${response.message}`,
        showRegisterButton:
          this.controllerData.newuser && this.getUser.credentials === "full"
            ? true
            : false,
        color: response.status === "0" ? "rgba(76, 175, 80, 0.9)" : "red"
      };
      this.alertToggle = true;
    },
    authAction() {
      if (this.getUser.credentials === "readonly") {
        router.push("/login");
      } else if (this.getUser.credentials === "full") {
        this.openResetAuth = true;
      }
    },
    closeLogoutModal() {
      this.openResetAuth = false;
    },
    closeContrllerModal() {
      this.controllerAction = false;
    },
    closeExpireModal() {
      this.expireModalToggle = false;
    },
    async stopController() {
      let response;
      try {
        response = await GlobalService.saveFieldData(
          this.controllerOn ? "misc.stop" : "misc.start",
          this.controllerOn ? "misc.stop" : "misc.start",
          this.getUser.token,
          1
        );
      } catch (e) {
        let resObj = { status: 1, message: "Try again later" };
        this.showResetAlarmFlash(resObj);
        this.closeContrllerModal();
      }
      this.showResetAlarmFlash(response);
      this.closeContrllerModal();
    },
    // open info messages modal
    openInfoMessagesModal() {
      this.infoMessagesData = this.controllerData.infomessages;
      this.infoMessageModal = true;
    },
    // close info messages modal
    closeInfoMessagesModal() {
      this.infoMessageModal = false;
    },
    closeConditionsModal() {
      this.openConditionDialog = false;
      this.userLogout();
    },
    async acceptTerms() {
      let response = await GlobalService.acceptTerms(
        "2",
        0,
        this.getUser.token
      );
      if (response.status === "0") {
        this.openConditionDialog = false;
      }
    },
    openPlans() {
      router.push("/system/settings/payment");
    }
  }
};
</script>

<style>
/* Homepage */
.controller-on {
  color: green;
}
.on-button-text.boiler-top-text {
  top: -23% !important;
  color: #000 !important;
  pointer-events: none;
}
.on-button-text.boiler-bottom-text {
  top: 80% !important;
}
.main-page-list {
  background: rgba(255, 255, 255, 0.5);
  border-radius: 5px;
  min-height: 22px;
  font-size: 14px;
  margin-bottom: 2px;
  padding: 0 16px;
  white-space: nowrap;
}
.reset-alarm {
  background: rgb(84, 110, 122) !important;
  opacity: 0.8;
  float: right;
  margin: 10px 0;
  color: #fff !important;
}
.d-menu-bar {
  display: flex;
  align-items: center;
  justify-content: center;
}
html.home-page,
.home-page .application,
.home-page body {
  overflow: hidden;
  height: 100%;
}
.home-page .sub-menu-small .v-btn {
  margin: 0;
}
.home-page .h-auto .v-btn .v-btn__content .v-image__image {
  opacity: 0.7;
}
.home-page .main-page {
  background: url(../assets/images/bg3.jpg) no-repeat 50% 100% !important;
  background-size: cover !important;
  height: 100%;
}
@media (max-height: 768px) {
  .home-page body {
    zoom: 0.9;
  }
}
/* @media (max-height: 700px) {
  .home-page body {
    zoom: 0.8;
  }
} */
@media (max-height: 600px) {
  .home-page body {
    zoom: 0.8;
  }
}
@media (max-width: 480px) {
  .home-page body {
    zoom: 0.9 !important;
  }
  html.home-page,
  .home-page .application,
  .home-page body {
    overflow: inherit !important;
  }
}
/* option List */
.v-menu__content {
  z-index: 777 !important;
}
.optionList .v-text-field > .v-input__control > .v-input__slot:before,
.optionList .v-input__append-inner {
  display: none;
}
.optionList
  .v-text-field.v-input--is-focused
  > .v-input__control
  > .v-input__slot:after {
  -webkit-transform: scaleX(0);
  transform: scaleX(0);
}
.optionList .v-text-field__details {
  display: none;
}
.optionList .v-text-field .v-label--active {
  transform: translateY(0px) scale(1);
}
.optionList {
  background-color: transparent !important;
  padding: 0;
}
.optionList .v-input,
.optionList .v-input__slot {
  margin: 0;
  padding: 0;
}
.optionList .v-input {
  background: rgba(255, 255, 255, 0.5);
  -moz-border-radius: 5px;
  border-radius: 5px;
  min-height: 22px;
  margin-bottom: 2px;
  padding: 0 16px;
  font-size: 14px;
  white-space: nowrap;
}
.optionList .v-input span span:first-child {
  min-width: 70px;
  margin-right: 8px;
  display: inline-block;
}
.optionList .v-select__slot label {
  font-size: 14px;
  font-weight: 400;
  height: auto;
  color: rgba(0, 0, 0, 0.87) !important;
  line-height: 11px;
  position: relative;
  padding: 0 15px;
}
.optionList .v-text-field input {
  padding: 0 10px;
}
.optionList .add-option {
  width: 18px;
  height: 18px;
  background: url(../assets/images/add.png) no-repeat center center;
  background-color: rgba(255, 255, 255, 0.5);
  -moz-border-radius: 4px;
  border-radius: 4px;
  -moz-background-size: 8px;
  background-size: 8px;
  min-width: 18px;
  float: right;
}
.optionList .add-option .v-select__selections {
  position: relative;
  right: 15px;
  min-width: 30px;
}

.v-select__selections {
  padding-right: 30px;
}
.ref-oxygen {
  position: absolute;
  right: 0;
}
/* notification-block */

.notification-block {
  position: relative;
  background: rgba(255, 255, 255, 0.5);
  border: 2px solid rgba(255, 255, 255, 0.8);
  -moz-border-radius: 10px;
  border-radius: 10px;
  min-height: 115px;
}
.notification-block .main-info h4 {
  margin: 4px 0;
  position: absolute;
  right: 15px;
  top: 10px;
}
@media (max-height: 900px) {
  .notification-block {
    min-height: 125px;
  }
}
.info-buttons .h-auto .v-btn .v-btn__content .v-image__image {
  width: 32px;
  border-radius: 6px;
}
.info-buttons span {
  font-size: 13px;
}
/* Boiler-block */
.boiler-block {
  display: flex;
  justify-content: flex-end;
  position: relative;
}
.boiler-block .boiler-button {
  flex: 1 1 33.33%;
  max-width: 33.33%;
  max-height: 100%;
  box-sizing: border-box;
  height: auto;
  position: relative;
}
.boiler-block .v-image__image {
  background-size: 100% 100%;
}
.boiler-block .on-button-text {
  position: absolute;
  width: 100%;
  top: 45%;
  bottom: 50%;
  line-height: 20px;
  z-index: 2;
  color: #fff;
}
@media (max-height: 900px) {
  .boiler-block .main-page-list {
    max-width: 100%;
  }
  .boiler-block .v-list {
    -ms-flex: 1 1 60%;
    -webkit-box-flex: 1;
    -moz-box-flex: 1;
    flex: 1 1 60%;
    max-width: 100%;
    max-height: 100%;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  .boiler-block .boiler-button {
    max-width: 175px;
    margin: 0;
  }
  .boiler-block .boiler-button-1 {
    min-width: 175px;
  }
  .boiler-block .boiler-button-2 {
    min-width: 153px;
  }
  .boiler-block .boiler-button-3 {
    min-width: 136px;
  }
  .boiler-block .boiler-button .v-image {
    height: 300px;
    width: 100%;
    max-width: 100%;
  }
}

/* Hopper Block */
.info-buttons {
  position: relative;
  top: 5%;
  max-height: 130px;
}
.hopper-block {
  justify-content: flex-start;
}
@media (max-height: 900px) {
  .boiler-block.hopper-block .boiler-button .v-image {
    width: 100%;
    max-width: 100%;
    height: 400px;
  }
}
@media (max-height: 700px) {
  .selector-block {
    margin-top: 0;
  }
  .devices-info {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 55;
  }
  .boiler-block.hopper-block .boiler-button .v-image {
    height: 380px;
  }
  .boiler-block .boiler-button .v-image {
    height: 285px;
  }
  /* .home.sub-menu {
    max-height: 95px !important;
  } */
  .home-page .sub-menu-small .v-btn span {
    padding: 0 !important;
  }
  .info-buttons {
    top: -35px;
  }
}

/* dhw Block */
@media (min-height: 900px) {
  .boiler-block .boiler-button {
    max-width: 26.33%;
  }
}
@media (max-height: 900px) {
  .boiler-block.dhw-device-block .boiler-button .v-image {
    height: 290px;
    width: 100%;
    max-width: 90%;
  }
}
.dhw-device-block {
  justify-content: flex-start;
}
@media (max-width: 1024px) {
  .padded-right-zero {
    padding-right: 0 !important;
  }
  .home-page .sub-menu-small .v-btn {
    min-width: 70px;
  }
  /* .boiler-block {
    height: 100%;
  } */
  .optionList .v-input {
    padding: 0 8px;
  }
  .boiler-button .v-image {
    height: 395px;
  }
  .hopper-block .v-image {
    height: 420px;
  }
}
@media (max-width: 1400px) {
  .max-height28 {
    padding: 0 15px;
  }
}
@media (max-width: 1200px) {
  .main-page-list {
    font-size: 13px !important;
    padding: 0 6px !important;
  }
  .main-page-list div {
    padding-right: 3px;
  }
}
@media (max-width: 1440px) and (min-width: 1264px) {
  .weather-comp {
    flex-basis: 24% !important;
    max-width: 24% !important;
  }
}
.boiler-block .v-list input,
.optionList .v-text-field input {
  padding: 0 !important;
}

.blink-area {
  -webkit-animation: colorchange 3s linear infinite;
  -moz-animation: colorchange 3s linear infinite;
  animation: colorchange 3s linear infinite;
}

@-webkit-keyframes colorchange {
  0% {
    background: rgba(255, 255, 255, 0.5);
  }
  50% {
    background: #d63d42;
    border: 2px solid #c1161f;
  }
  100% {
    background: rgba(255, 255, 255, 0.5);
  }
}

@-moz-keyframes colorchange {
  0% {
    background: rgba(255, 255, 255, 0.5);
  }
  50% {
    background: #d63d42;
    border: 2px solid #c1161f;
  }
  100% {
    background: rgba(255, 255, 255, 0.5);
  }
}

@keyframes colorchange {
  0% {
    background: rgba(255, 255, 255, 0.5);
  }
  50% {
    background: #d63d42;
    border: 2px solid #c1161f;
  }
  100% {
    background: rgba(255, 255, 255, 0.5);
  }
}
.home.sub-menu.sub-menu-small-1 {
  margin-left: 4%;
  max-width: 480px;
  position: relative;
  z-index: 66;
  justify-content: flex-start;
}
.sub-menu-small-1 .inner-buttons .v-btn {
  min-width: 50px !important;
  width: 50px !important;
  padding: 0;
  box-shadow: none;
}
.inner-buttons > div {
  width: 50px;
  margin: 0 40px 3px 0;
}

/* mobile design */

.mobile-screen {
  display: none;
  background: #0e6478;
  height: 100%;
  width: 100%;
}
@media (max-width: 768px) {
  .desktop-screen {
    display: none !important;
  }
  .mobile-screen {
    display: block;
  }
  .notification-block .main-info h4 {
    font-weight: 300;
  }
  .home.sub-menu.sub-menu-small-1 {
    max-width: 100% !important;
    justify-content: flex-start;
    margin: 10px;
  }
  .sub-menu-small-1 .inner-buttons .v-btn {
    color: #fff;
  }
  .home.sub-menu.sub-menu-small-1 .v-responsive.v-image {
    height: 30px !important;
    width: 30px !important;
  }
  .home.sub-menu.sub-menu-small-1 .v-responsive.v-image .v-image__image {
    border-radius: 5px;
    height: 30px !important;
    width: 30px !important;
  }
  .devices-info-field {
    padding: 0 10px;
    margin: 0 8px 8px;
    border: 2px solid rgba(255, 255, 255, 0.6);
    -moz-border-radius: 5px;
    border-radius: 5px;
    overflow-y: scroll !important;
    max-height: 50vh;
    padding-bottom: 30px;
    position: fixed;
    bottom: 10px;
    left: 0;
    right: 0;
  }
  .devices-info-field .boiler-info {
    margin: 10px;
    color: #fff;
    display: flex;
    align-items: center;
  }
  .devices-info-field .boiler-info img {
    width: 30px;
    height: 30px;
    margin-right: 10px;
  }
  .home-page-md-list-first,
  .home-page-md-list {
    padding: 0;
  }
  .home-page-md-list-first li,
  .home-page-md-list li {
    position: relative;
    background: rgba(255, 255, 255, 0.5);
    -moz-border-radius: 5px;
    border-radius: 5px;
    font-size: 14px;
    margin-bottom: 2px;
    list-style: none;
    display: flex;
    justify-content: flex-start;
  }
  .home-page-md-list-first li {
    justify-content: center;
  }
  .home-page-md-list li span:first-child {
    min-width: 110px;
    display: inline-block;
  }
  .home-page-md-list li span {
    padding: 0 10px;
  }
  .menu-button {
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
    color: rgb(33, 33, 33);
    display: inline-block;
    background-color: #fff !important;
    border-radius: 3px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 6px;
    margin: 6px 8px;
    line-height: 36px;
    min-height: 36px;
    white-space: nowrap;
    min-width: 45px;
    text-align: center;
    text-transform: uppercase;
    font-weight: 500;
    font-size: 14px;
    position: fixed;
    top: 20px;
    left: 15px;
  }
  .menu-button svg {
    height: 24px;
    width: 24px;
  }
  .reg-v-alert.v-alert.v-alert {
    position: fixed;
    top: inherit;
    bottom: 0;
    right: 8px;
    left: 8px;
    border-radius: 0;
  }
  .expire-v-alert.v-alert.v-alert {
    position: fixed;
    top: inherit;
    bottom: 60px;
    right: 8px;
    left: 8px;
    border-radius: 0;
  }
  .reg-v-alert div,
  .expire-v-alert div {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .weather-comp {
    flex-basis: 100% !important;
    max-width: 100% !important;
  }
  .weather-comp .main-page-list:first-child {
    background-color: transparent;
    color: #fff;
    font-size: 16px;
    margin: 10px 0;
  }
  /* sidebar */
  .sidebar-bg {
    background-color: rgba(33, 33, 33, 0.4);
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 1111;
    display: none;
  }
  .sidebar-menu {
    overflow-y: auto;
    position: fixed;
    left: 0;
    width: 320px;
    bottom: 0;
    background-color: rgb(255, 255, 255);
    top: 0;
    z-index: 11111;
    transform: translate3d(-100%, 0, 0);
    box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2),
      0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12);
    -moz-transition: 0.2s linear;
    -webkit-transition: 0.2s ease-out;
    transition: 0.2s linear;
  }
  .open-sidebar-menu {
    transform: translate3d(0, 0, 0);
  }
  .display-block {
    display: block;
  }
  .home-page .h-auto .v-btn .v-btn__content .v-image__image {
    opacity: 1;
  }
  .sidebar-menu .sub-menu-small .v-btn,
  .application a {
    width: 100% !important;
    margin: 0 !important;
  }
  .sidebar-menu .sub-menu .v-btn__content,
  .application a .v-btn__content {
    display: flex;
    flex-direction: row !important;
    justify-content: flex-start !important;
  }
  .sidebar-menu .sub-menu.sub-menu-small:nth-child(3) .v-btn:first-child {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  }
  .sidebar-menu .sub-menu-small .v-responsive,
  .application a .v-btn__content .v-responsive {
    max-width: 50px;
    margin-right: 5px;
    max-height: 40px;
  }
  .sidebar-menu .sub-menu .v-btn__content,
  .application a .v-btn__content {
    font-size: 20px;
    font-weight: 500;
    letter-spacing: 0.005em;
  }
  .logo-item {
    background: #000;
    padding: 20px 0 16px 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 15px;
  }
  .sidebar-menu .sub-menu {
    display: block !important;
  }
  .home-page .home.sub-menu {
    max-height: inherit !important;
    display: flex !important;
  }
  .v-dialog__content {
    z-index: 6666666 !important;
  }
  .v-dialog {
    max-width: 600px !important;
  }
  .v-overlay.v-overlay--active {
    z-index: 666666 !important;
  }
}
@media (max-width: 1400px) {
  .home.sub-menu.sub-menu-small-1 {
    margin-left: 20%;
  }
}
@media (max-width: 1170px) {
  .home.sub-menu.sub-menu-small-1 {
    margin-left: 10%;
  }
}
@media (min-width: 2560px) {
  .home.sub-menu.sub-menu-small-1 {
    margin-left: 20%;
  }
}
@media (max-width: 480px) {
  .inner-buttons > div {
    margin: 0 10px 3px 0;
  }
  .home.sub-menu.sub-menu-small-1 {
    margin-left: 0;
  }
}
</style>

<style scoped>
.selector-block {
  margin-top: 26px;
}
.home.sub-menu {
  max-height: 125px;
  flex-wrap: nowrap;
}
.sub-menu-small {
  flex-wrap: wrap !important;
}
.inner-buttons {
  display: block;
}
.sub-menu-small .v-image .v-image__image {
  max-width: 44px !important;
  max-height: 44px;
}
.sub-menu-small .v-btn {
  min-width: 55px;
  margin: 0 5px;
  width: 70px;
  text-transform: capitalize;
}
.max-height28 {
  max-height: 28%;
}
.colored-box {
  display: inline-block;
  width: 0.75em;
  height: 0.75em;
  border-radius: 0.75em;
  align-self: center;
  margin-right: 0.2em;
}
</style>
